import React from 'react';
import './Tooltip.css';

const Tooltip = ({ children, content, offset }) => (
  <div className="tooltip">
    {children}
    <span className="tooltiptext" style={{ marginLeft: offset }}>
      {content}
    </span>
  </div>
);

export default Tooltip;
